import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Process } from '../Types';
import { AuthTokenResponse, AuthUser } from '../types/auth.types';

interface ConfigReduxState {
  /** In-house API access token (JWT). Persisted to localStorage by redux-persist. */
  accessToken: string;
  accessTokenExpiresAt: string;
  refreshToken: string;
  authUser: AuthUser | null;
  processesArray: Process[];
  isAuthReady: boolean;
}

const initialState: ConfigReduxState = {
  accessToken: '',
  accessTokenExpiresAt: '',
  refreshToken: '',
  authUser: null,
  processesArray: [],
  isAuthReady: false
};

export const configSlice = createSlice({
  name: 'config',
  initialState: { ...initialState },
  reducers: {
    setAuthSession: (state, action: PayloadAction<AuthTokenResponse>) => {
      state.accessToken = action.payload.accessToken;
      state.accessTokenExpiresAt = action.payload.accessTokenExpiresAt;
      state.refreshToken = action.payload.refreshToken;
      state.authUser = action.payload.user;
    },
    clearAuthSession: (state) => {
      state.accessToken = '';
      state.accessTokenExpiresAt = '';
      state.refreshToken = '';
      state.authUser = null;
    },
    addProcess: (state, action: PayloadAction<Process>) => {
      state.processesArray.push(action.payload);
    },
    deleteProcess: (state, action: PayloadAction<number>) => {
      state.processesArray = state.processesArray.filter(
        (process) => process.id !== action.payload
      );
    },
    clearAllProcesses: (state) => {
      state.processesArray = [];
    },
    clearConfigSlice: () => {
      return initialState;
    },
    setAuthReady: (state, action: PayloadAction<boolean>) => {
      state.isAuthReady = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  setAuthSession,
  clearAuthSession,
  addProcess,
  deleteProcess,
  clearAllProcesses,
  clearConfigSlice,
  setAuthReady
} = configSlice.actions;

export default configSlice.reducer;
